import React from "react";
import companyLogo from "../../assets/Kmodo_full_cropped.png";

export const KmodoLogoLarge = () => {
  return <img alt="company-logo" src={companyLogo} width="125px" />;
};
